import React from "react";
import styles from "./Assessment2Form.module.css";
import quiz from "../../../json/Quiz.json";
import Assessment2Shell, { RailLens } from "../Assessment2Shell/Assessment2Shell";
import UserInfoForm from "../UserInfoForm/UserInfoForm";

const cfg = quiz.assessment2;
const f = cfg.form;

/* Step 4 of 4 — "Your Practice Snapshot" details form inside the
   shared Assessment 2 shell. Reuses the existing UserInfoForm (with its
   ZIP → state lookup and NPI verification). */
const Assessment2Form = ({
  userInfo,
  setUserInfo,
  submitAttempted,
  onExit,
  onBack,
  onNext,
  nextDisabled,
}) => {
  const rail = (
    <>
      <span className={styles.railEyebrow}>{f.eyebrow}</span>
      <h1 className={styles.railTitle}>{f.title}</h1>
      <p className={styles.railText}>{f.railText}</p>
      <RailLens />
    </>
  );

  return (
    <Assessment2Shell
      stepIndex={3}
      stepLabel={f.stepLabel}
      rail={rail}
      railFilled
      onExit={onExit}
      onBack={onBack}
      onNext={onNext}
      nextDisabled={nextDisabled}
    >
      <div className={styles.mainHead}>
        <h2 className={styles.mainTitle}>{f.heading}</h2>
        <p className={styles.mainDesc}>{f.description}</p>
      </div>
      <UserInfoForm
        values={userInfo}
        onChange={setUserInfo}
        submitAttempted={submitAttempted}
        roleOptions={quiz.form.roleOptions}
        consent={quiz.form.consent}
      />
    </Assessment2Shell>
  );
};

export default Assessment2Form;
